export default "__VITE_ASSET__ae0bd2db__"